import { EditAnnouncementListPage } from './EditAnnouncementListPage';
export default EditAnnouncementListPage;
